import { render, staticRenderFns } from "./EditActive.vue?vue&type=template&id=166a615f&scoped=true&"
import script from "./EditActive.vue?vue&type=script&lang=js&"
export * from "./EditActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166a615f",
  null
  
)

export default component.exports